import axios from "axios";

const Config = axios.create({
  baseURL: "https://berrybloomer.com/api",
});

// 🔑 Token automatically attach (JWT)
Config.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

export default Config;